import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { CpErrorManagementProviderService } from '../../providers/error-management-provider/error-management-provider.service';
import { Router } from '@angular/router';

export const cpErrorsInterceptor: HttpInterceptorFn = (req, next) => {
  const errorManagementProviderService: CpErrorManagementProviderService = inject(CpErrorManagementProviderService);
  const router: Router = inject(Router);
  const resultCodeUnauthorized = [-505];

  return next(req).pipe(
    catchError((err): Observable<any> => {
      if (resultCodeUnauthorized.some((row) => row == err.error.resultCode)) {
        sessionStorage.clear();
        router.navigateByUrl('/login', {replaceUrl: true});
      }

      errorManagementProviderService.GetError(err);
      return throwError(err);
    })
  );
};
